import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import useSEO from "@/lib/useSEO";
import { Hammer, Building2, HandCoins, TrendingUp, ArrowRight } from "lucide-react";

const ICONS = { hammer: Hammer, building: Building2, "hand-coins": HandCoins, "trending-up": TrendingUp };

export default function Hizmetler() {
  useSEO({
    title: "Hizmetlerimiz",
    description: "Müteahhitlik, yap-sat, yatırım değerlendirme ve anahtar teslim inşaat hizmetleri.",
    path: "/hizmetler",
  });
  const [services, setServices] = useState([]);
  useEffect(() => { api.get("/services").then((r) => setServices(r.data)).catch(() => {}); }, []);

  return (
    <div className="min-h-screen bg-[#0A0E1A]" data-testid="hizmetler-page">
      <section className="py-24 lg:py-32 border-b border-[#1F2937]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <div className="section-label mb-6">Hizmetlerimiz</div>
          <h1 className="font-heading text-4xl lg:text-6xl text-white tracking-[0.05em] leading-tight max-w-3xl">
            Uçtan Uca<br />
            <span className="text-[#C9A961]">Müteahhitlik Çözümleri</span>
          </h1>
          <p className="mt-8 max-w-2xl text-white/70 leading-relaxed">
            Konut projelerinden ticari yapılara, anahtar teslim inşaattan yatırım danışmanlığına kadar geniş bir hizmet yelpazesi sunuyoruz.
          </p>
        </div>
      </section>

      <section className="py-24">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid md:grid-cols-2 gap-6">
          {services.map((s, i) => {
            const Icon = ICONS[s.icon] || Hammer;
            return (
              <div key={s.id} className="yk-card p-10 group" data-testid={`service-card-${s.id}`}>
                <div className="flex items-start gap-6">
                  <div className="w-16 h-16 border border-[#C9A961]/40 flex items-center justify-center shrink-0 group-hover:bg-[#C9A961] transition-colors">
                    <Icon className="w-8 h-8 text-[#C9A961] group-hover:text-[#0A0E1A] transition-colors" strokeWidth={1.2} />
                  </div>
                  <div>
                    <div className="text-[10px] text-[#C9A961] uppercase tracking-[0.3em] mb-2">0{i + 1}</div>
                    <div className="font-heading text-2xl text-white tracking-[0.1em] mb-3 uppercase">{s.title}</div>
                    <div className="text-white/60 leading-relaxed">{s.description}</div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </section>

      <section className="py-16 border-t border-[#1F2937]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <div className="section-label mb-3">Projeniz için hazırız</div>
            <h3 className="font-heading text-2xl lg:text-3xl text-white tracking-widest">Hemen İletişime Geçin</h3>
          </div>
          <Link to="/iletisim" className="btn-gold">İletişim <ArrowRight className="w-4 h-4" /></Link>
        </div>
      </section>
    </div>
  );
}
